/**
 * Takes the pointer, preferring raw movement.
 *
 * `unadjustedMovement: true` bypasses OS mouse acceleration — the difference
 * between "floaty" and 1:1 aiming. Browsers without it reject the promise, so
 * fall back to a plain lock. Must be called inside a user gesture.
 *
 * Lives outside the components so the interface can resume mouse look without
 * importing the Three.js bundle.
 */
export function requestLookLock(canvas = document.querySelector('.experience canvas')) {
  if (!canvas || document.pointerLockElement === canvas) return;

  try {
    const request = canvas.requestPointerLock({ unadjustedMovement: true });
    if (request?.catch) request.catch(() => {
      try { canvas.requestPointerLock?.()?.catch?.(() => {}); } catch { /* A later click can retry. */ }
    });
  } catch {
    try { canvas.requestPointerLock?.()?.catch?.(() => {}); } catch { /* Touch and keyboard remain available. */ }
  }
}
